import React from "react";
import { Box, MainText } from "app/components/common";
import * as Progress from "react-native-progress";
import theme from "app/Theme/Theme";

interface IProps {
  progress: number;
  number: number;
  legend: string;
  color: string;
}

const ReviewCircleStat = ({
  progress = 0.1,
  legend = "",
  number = 0,
  color = theme.colors["brand.500"],
}: IProps) => {
  return (
    <Box alignItems="center" justifyContent="center" flexDirection="column">
      <Box flexDirection="column" alignItems="center" justifyContent="center">
        <Box position="absolute">
          <MainText variant="l4-bold">{number}</MainText>
        </Box>
        <Progress.Circle
          progress={progress}
          size={44}
          thickness={2.5}
          strokeCap={"round"}
          animated={true}
          useNativeDriver
          borderWidth={0}
          color={color}
          fill={"transparent"}
        />
      </Box>
      <MainText variant="l3-medium" marginTop="m">
        {legend}
      </MainText>
    </Box>
  );
};

export default ReviewCircleStat;
